import "./ScoreElement.css";
import { Score } from "./Score";
import { Time } from "./Time";

export class ScoreElement extends HTMLElement {
  left = document.createElement("div");
  center = document.createElement("div");
  right = document.createElement("div");

  constructor(readonly model: Score) {
    super();
    this.append(this.left, this.center, this.right);
    document.body.append(this);
    this.render();
  }

  render() {
    if (this.parentNode) requestAnimationFrame(this.render.bind(this));
    this.left.innerText = `Highscore: ${this.model.highscore}`;
    this.center.innerText = `Score: ${this.model.count}`;
    this.right.innerText = this.model.time.toString();
  }
}

customElements.define("score-element", ScoreElement);
